import React from "react";
import PropTypes from "prop-types";
import { styled, useMediaQuery, useTheme } from "@mui/material";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const DatePickerWrapper = styled("div")(({ theme }) => ({
  maxWidth: 132,
  "& .react-datepicker-wrapper": {
    display: "block",
    width: "100%",
  },
  "& .react-datepicker__input-container input": {
    width: "100%",
    height: "36px",
    paddingLeft: "8px",
    fontSize: "12px",
    border: "1px solid",
    borderColor: theme.palette.neutral.main,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: "transparent",
    color: theme.palette.text.primary,
    fontFamily: theme.typography.fontFamily,
    "&:focus": {
      outline: `1px solid ${theme.palette.primary.main}`,
      boxShadow: `0 0 0 2px ${theme.palette.primary.main}33`,
    },
  },
  "& .react-datepicker__calendar-icon": {
    position: "absolute",
    right: "0px",
    top: "50%",
    transform: "translateY(-50%)",
    fill: theme.palette.text.primary,
  },
  "& .react-datepicker-popper": {
    zIndex: 999,
    width: "auto",
  },
  "& .react-datepicker": {
    fontFamily: theme.typography.fontFamily,
    fontSize: "0.875rem",
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.grey[200]}`,
    boxShadow: theme.shadows[4],
  },
}));

const DateTimePicker = ({ selectedTime, setSelectedTime }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <DatePickerWrapper>
      <DatePicker
        selected={selectedTime}
        onChange={(time) => setSelectedTime(time)}
        showTimeSelect
        dateFormat="dd/MM/yyyy HH:mm"
        timeIntervals={5}
        showIcon={!isMobile}
        toggleCalendarOnIconClick
      />
    </DatePickerWrapper>
  );
};

DateTimePicker.propTypes = {
  /** Thời gian đang chọn, bắt buộc là Date */
  selectedTime: PropTypes.instanceOf(Date).isRequired,

  /** Hàm cập nhật lại selectedTime */
  setSelectedTime: PropTypes.func.isRequired,
};

export default DateTimePicker;
